import type { FC, PropsWithChildren } from 'react';

import type { TStyledTextValidator } from '../select-native/styles';
import { StyledTextValidator } from '../select-native/styles';
import Skeleton from '../skeleton';

export type TValidatedInputFieldProps = PropsWithChildren<
  {
    value?: string;
    preload?: boolean;
    width?: string | number;
    className?: string;
  } & TStyledTextValidator
>;

const ValidatedInputField: FC<TValidatedInputFieldProps> = ({
  preload,
  width,
  className,
  variant = 'outlined',
  margin = 'normal',
  size = 'small',
  ...rest
}) => {
  if (preload) {
    return <Skeleton width={width} height={48} variant="rectangular" className={`${className || ''}`} />;
  }

  return <StyledTextValidator className={className || ''} variant={variant} margin={margin} size={size} {...rest} />;
};

export default ValidatedInputField;
